import { pgTable, text, unique } from 'drizzle-orm/pg-core';
import { orgPrimaryKey, orgTableBase } from './org-id';
/**
 * Profiles an org admin explicitly deselected from the coach list. Records
 * admin intent so coach-derivation paths (TUM app access rules, directory
 * events, org re-syncs) can never re-grant coach access to these profiles in
 * this org, even when Axle's user types would mark them as coaches.
 *
 * Keyed by axleProfileId (not a Profile FK) so the entry survives the SC
 * profile being deleted and re-imported.
 */
export const CoachDenyList = pgTable('coach_deny_list', {
    ...orgTableBase,
    axleProfileId: text('axle_profile_id').notNull(),
}, (table) => ({
    pk: orgPrimaryKey(table),
    axleProfileUq: unique().on(table.orgId, table.axleProfileId),
}));
//# sourceMappingURL=coach-deny-list.js.map